
import Vue from "vue";
import { AuthService } from "../../services/auth-service";
export default Vue.extend({
	data(){
		return {
			AuthService,
		};
	},
	watch: {
		"AuthService.wfCompany.ActiveUntil": {
			immediate: true,
			handler(){
				if (!AuthService.wfCompany.isExpired()){
					this.$router.push("/home");
				}
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
